import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoService from '../../servicos/ConsultaRemuneracaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaRemuneracaoInicio: [],
    buscaConsultaRemuneracaoSucesso: ['consultaRemuneracao'],
    buscaConsultaRemuneracaoErro: ['erro'],
    setSelecionadoConsultaRemuneracaoSucesso: ['selecionado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
}

// Ação para busca completa
Creators.buscaConsultaRemuneracao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaRemuneracaoInicio())
        let serv = new ConsultaRemuneracaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaRemuneracaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaRemuneracaoErro(error)))
    }
}

const buscaConsultaRemuneracaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaRemuneracaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaRemuneracaoSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaRemuneracao.resultado,
        dataSincronizacaoDados: action.consultaRemuneracao.dataSincronizacaoDados,
        carregando: false,
    }
}

const setSelecionadoConsultaRemuneracaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_REMUNERACAO_INICIO]: buscaConsultaRemuneracaoInicio,
    [Types.BUSCA_CONSULTA_REMUNERACAO_ERRO]: buscaConsultaRemuneracaoErro,
    [Types.BUSCA_CONSULTA_REMUNERACAO_SUCESSO]: buscaConsultaRemuneracaoSucesso,
    [Types.SET_SELECIONADO_CONSULTA_REMUNERACAO_SUCESSO]: setSelecionadoConsultaRemuneracaoSucesso,
})
